import { createActions } from 'redux-actions';
import { request, upload } from '../../services';
import { camelCase } from 'lodash';

const {
  uploadsListRequest,
  uploadsListRequestSuccess,
  uploadsListRequestFailure,
} = createActions({
  UPLOADS_LIST_REQUEST_SUCCESS: (json, type, page) =>
    ({ data: json, type, page }),
}, 'UPLOADS_LIST_REQUEST', 'UPLOADS_LIST_REQUEST_FAILURE');

export function getUploadsList(type, page) {
  return (dispatch, getState) => {
    const state = getState();
    const uploadKey = camelCase(type);
    const newPage = page || state[uploadKey].page;

    dispatch(uploadsListRequest({ type, newPage }));
    return request(`${type}?page=${newPage}`)
      .then(({ json }) => dispatch(uploadsListRequestSuccess(json, type, page)))
      .catch(errors => dispatch(uploadsListRequestFailure({ errors, type })));
  };
}

const {
  uploadsFileUpload,
  uploadsFileUploadSuccess,
  uploadsFileUploadFailure,
} = createActions({
  UPLOADS_FILE_UPLOAD_SUCCESS: (json, type) => ({ data: json, type }),
}, 'UPLOADS_FILE_UPLOAD', 'UPLOADS_FILE_UPLOAD_FAILURE');

export function uploadFile(formData, type) {
  return (dispatch) => {
    dispatch(uploadsFileUpload({ type }));
    return upload(formData, type)
      .then(({ json }) => dispatch(uploadsFileUploadSuccess(json[type.slice(0, -1)], type)))
      .catch(errors => dispatch(uploadsFileUploadFailure({ errors: errors.errors, type })));
  };
}

export function toggleDialog(status, type) {
  return (dispatch) => {
    dispatch({ type: 'UPLOAD_DIALOG_TOGGLE', payload: { status, type } });
  };
}

export function setErrorMessage(errors, type) {
  return (dispatch) => {
    dispatch({ type: 'UPLOADS_FILE_UPLOAD_FAILURE', payload: { errors, type } });
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/uploads.js